import {combineReducers} from 'redux'
import chatbotVisibilityReducer from './slices/chatbotVisibility';
import chatbotFlowReducer from './slices/chatbotFlow';
import chatbotDetailsReducer from './slices/chatbotDetails';
import chatbotInputReducer from './slices/chatbotInput';

export default combineReducers({
    chatbotVisibility: chatbotVisibilityReducer,
    chatbotFlow: chatbotFlowReducer,
    chatbotDetails: chatbotDetailsReducer,
    chatbotInput: chatbotInputReducer,
})